import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import DropdownMenuItem from "./DropdownMenuItem"
import useOutsideClick from '../../../common/hooks/useOutsideClick'

const DropdownMenu = ({
  getAllDestinations,
  setDropdownOptionHoverState,
  getActiveHoveredState,
  selectDropdownOption,
  menu,
  closeOpenDropdown
}) => {
  const dropdownRef = useRef()
  const {outsideClick} = useOutsideClick({outsideRef: dropdownRef, onEveryClick: true})

  useEffect(() => {
    if(outsideClick.click) {
      closeOpenDropdown("destination")
    }
  },[outsideClick])

  const outputDropdownItems = () => {
    const items = getAllDestinations()
    return items.map((item, i) => {
      return (
        <DropdownMenuItem
          item  = {item}
          key   = {i}
          menu  = { menu }
          getActiveHoveredState       = { getActiveHoveredState }
          setDropdownOptionHoverState = { setDropdownOptionHoverState }
          selectDropdownOption        = { selectDropdownOption }
        ></DropdownMenuItem>
      )
    })
  }

  return (
    <div className="dropdown-menu-items drop-down-items-container-1">
      <div className="drop-down-items-container-2">
        <div
          role="menu"
          className="drop-down-items-container-3"
          ref={dropdownRef}>
          { outputDropdownItems() }
        </div>
      </div>
    </div>
  )
}

DropdownMenu.propTypes = {
  getAllDestinations: PropTypes.func.isRequired,
  setDropdownOptionHoverState: PropTypes.func,
  getActiveHoveredState: PropTypes.func,
  selectDropdownOption: PropTypes.func,
  menu: PropTypes.string,
  closeOpenDropdown: PropTypes.func.isRequired
}

export default DropdownMenu
